import DesignNameDialog from './DesignNameDialog';

export default DesignNameDialog;
